import React, { Component } from 'react';
/*import { connect } from 'react-redux';*/
import isEqual from 'lodash/isEqual';
import Portal from './Portal.jsx';
import { observer } from "mobx-react";

class CenterScroller extends Component {
  constructor(props) {
    super(props);
    this.state={

    };
    this._onResize=(e)=>{

      if(this.props.maxWidth) {
        this._ref.style.maxWidth=(this.props.maxWidth?this.props.maxWidth:700)+'px';
      }

      const win={
        width:window.innerWidth,
        height:window.innerHeight,
      };
      const curItem={
        width:this._ref.clientWidth,
        height:this._ref.clientHeight,
      };
      //.getBoundingClientRect()

      let newStyle={
        left:(win.width-curItem.width)/2
      };

      if(win.width<768) {
        newStyle.left=0;
      }

      if(newStyle.left<0) {
        newStyle.left=0;
      }

      if(this.props.center) {

        newStyle.top=(win.height-curItem.height)/2;

        if(newStyle.top<0) {
          newStyle.top=0;
        }
      }


      for(let i in newStyle) {
        this._ref.style[i]=newStyle[i]+'px';
      }



    };
  }
  componentDidMount() {
    this._onResize();
    document.getElementsByTagName("body")[0].style.overflow='hidden';
  }
  componentDidUpdate() {
      this._onResize();
  }
  componentWillUnmount() {
    window.removeEventListener('resize',this._onResize);
    document.getElementsByTagName("body")[0].style.overflow='visible';//this.props.unmountOverflow?this.props.unmountOverflow:this._saveOverflow;
    console.log('unmount this._saveOverflow', this.props.unmountOverflow, 'saved:',this._saveOverflow);
  }
  componentWillReceiveProps(nextProps) {
    console.log('fire resize!!!');
    if (nextProps.varsStore) {
      if (!isEqual(nextProps.varsStore.curVars,this.props.varsStore.curVars)) {
        if(this._mainWrap) {
          this._mainWrap.scrollTop=0;
        }
        //console.log('need scroll to top!',nextProps.varsStore.curVars,this.props.varsStore.curVars);
      } else {
        //console.log('need scroll to top! EQUAL!',nextProps.varsStore.curVars,this.props.varsStore.curVars);
      }
    }
  }
  componentWillMount() {
    window.addEventListener('resize',this._onResize);
    this._saveOverflow=document.getElementsByTagName("body")[0].style.overflow;
    document.getElementsByTagName("body")[0].style.overflow='hidden';
    console.log('mount this._saveOverflow',this._saveOverflow);
  }
  close() {
    if(this.props.closeTrigger) {
      this.props.closeTrigger();
    }
  }
  render() {
    return (
      <Portal>
        <div id="centerScrollerScroll" className="pf centerScroller pa-tl w100 h100 ofa" ref={(ref)=>{ this._mainWrap=ref; }} style={{zIndex:1000}}>
          <div className="pr" style={{minHeight:'100%'}}>
            <div className="pa pa-tl w100 bg-b1-op20" style={{minHeight:'100%'}} onClick={()=>{ this.close(); }}></div>
            <div className="pr" ref={(ref)=>{ this._ref=ref; }}>
              {this.props.children}
            </div>
          </div>
        </div>
      </Portal>
    )
  }
}

/*function mapStateToProps(state) {
  return {}
}*/

export default observer(CenterScroller);